import { createContext, useContext, useReducer } from 'react';
import produce from 'immer';

import { unimplemented } from '@utils/commonUtils';

type OpenAIKeys = 'insights.open_ai.system_message' | 'insights.open_ai.user_messages';

const OPEN_AI_KEYS = {
  SYSTEM_MESSAGE: 'insights.open_ai.system_message' as OpenAIKeys,
  USER_MESSAGES: 'insights.open_ai.user_messages' as OpenAIKeys,
  REMOVE_USER_MESSAGE: 'insights.open_ai.remove_user_message' as OpenAIKeys,
};

type Action = { type: OpenAIKeys; payload: string | number | null };

export interface IOpenAIContext {
  systemMessage: string | null;
  userMessages: string[];
  setSystemMessage: (systemMessage: string | null) => void;
  addUserMessage: (userMessage: string) => void;
  removeUserMessage: (index: number) => void;
}

const initialState: IOpenAIContext = {
  systemMessage: null,
  userMessages: [],
  setSystemMessage: unimplemented,
  addUserMessage: unimplemented,
  removeUserMessage: unimplemented,
};

const reducer = produce((draft: IOpenAIContext, action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case OPEN_AI_KEYS.SYSTEM_MESSAGE:
      draft.systemMessage = payload as string | null;
      break;

    case OPEN_AI_KEYS.USER_MESSAGES:
      draft.userMessages.unshift(payload as string);
      break;

    case OPEN_AI_KEYS.REMOVE_USER_MESSAGE:
      draft.userMessages.splice(payload as number, 1);
      break;
  }
}, initialState);

export const OpenAIContext = createContext<IOpenAIContext>(initialState);

export const OpenAIProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  function setSystemMessage(systemMessage: string | null) {
    dispatch({ type: OPEN_AI_KEYS.SYSTEM_MESSAGE, payload: systemMessage });
  }

  function addUserMessage(userMessage: string) {
    dispatch({ type: OPEN_AI_KEYS.USER_MESSAGES, payload: userMessage });
  }

  function removeUserMessage(index: number) {
    dispatch({ type: OPEN_AI_KEYS.REMOVE_USER_MESSAGE, payload: index });
  }

  const value = {
    ...state,
    setSystemMessage,
    addUserMessage,
    removeUserMessage,
  };

  return <OpenAIContext.Provider value={value}> {children} </OpenAIContext.Provider>;
};

export const useOpenAIContext = () => {
  return useContext(OpenAIContext);
};
